export default __webpack_public_path__ + "static/media/LogoIcon.689e463a.svg";